import {
  FURUI_FRUI_BASEDATA_MODAL_CHANGE,
} from './constants';

export function frui_basedataModalChange(visible,type) {
  return {
    type: FURUI_FRUI_BASEDATA_MODAL_CHANGE,
    data: {visible,type},
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case FURUI_FRUI_BASEDATA_MODAL_CHANGE:
      return {
        ...state,
        frui_basedataModalType:action.data.type,
        frui_basedataModalVisible:action.data.visible
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/furui/redux/frui_basedataModalChange.js